export const cancelEmailChange = gql`
    mutation cancelEmailChange(
        $email: String
    ) {
        cancelEmailChange(
            input: {
                email: $email,
            }
        ) {
            status
        }
    }
`
